module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_ PRINTING LEATHER_deskstop.65bcd252.jpg";